import React from 'react';
import { Table } from 'rsuite';

import '../css/widget/widget.page.table.css';
import '../css/widget/widget.table.css';
import 'rsuite/dist/styles/rsuite-default.css';

const { Pagination } = Table;

class WidgetPage extends React.Component
{
    constructor( props )
    {
        super(props);

        let records = 10;

        if( props.options!==undefined && props.options.records!==undefined )
        {
            records = props.options.records;
        }

        this.state = {
            page:1,
            records:records,
            total : this.props.total,
            pageFlag : this.props.pageFlag===true,
            disabled : false
        }

        this.handleChangePage = this.handleChangePage.bind(this);
    }

    handleChangePage(page)
    {
        if( this.props.pageTurning!==undefined )
        {
            this.props.pageTurning(page);
        }

        this.setState({page:page});
    }

    render()
    {
        const { page, records, disabled } = this.state;

        let { total } = this.props, { pageFlag } = this.state;

        if( total>0 )
        {
            pageFlag = true;
        }

        return (
            <div className="page-table">
                <div className="page-table-footer">
                    <Pagination 
                        style={pageFlag===true ? {display:"block"} : {display:"none"} }
                        disabled = {disabled}
                        activePage={page}
                        total={total}
                        classPrefix = {"table-page"}
                        displayLength = {records}
                        showLengthMenu={false}
                        reverse = {true}
                        onChangePage={this.handleChangePage}
                        // onChangeLength={this.handleChangeLength}
                        renderTotal = {
                            () => {
                                return (
                                    <div className="table-page-page-info">
                                        <span>总数: </span>
                                        <span>{total}</span>
                                        <span></span>
                                    </div>
                                )
                            }
                        } 
                    />
                </div>
            </div>
        )
    }

}
export default WidgetPage

export const PageTableFooter = ({ pageFlag, page, total, records, handleChangePage, disabled, options, handleCheckAll, ...props }) => 
{
    
}